import BorderBox from './components/BorderBox';
import Box from './components/Box';
import FlexBox from './components/FlexBox';
import Heading from './components/Heading';
import List from './components/List';
import Position from './components/Position';
import Text from './components/Text';
import TextInput from './components/TextInput';

export { default as appendPx } from './appendPx';
export { default as Anchor } from './components/Anchor';
export { default as BorderBox } from './components/BorderBox';
export { default as Box } from './components/Box';
export { default as Button } from './components/Button';
export { default as CheckboxInput } from './components/CheckboxInput';
export { default as Container } from './components/Container';
export { default as Divider } from './components/Divider';
export { default as FlexBox } from './components/FlexBox';
export { default as Grid } from './components/Grid';
export { default as Heading } from './components/Heading';
export { default as List } from './components/List';
export { default as OffsetBox } from './components/OffsetBox';
export { default as Position } from './components/Position';
export { default as Rhythm } from './components/Rhythm';
export { default as Stack } from './components/Stack';
export { default as Text } from './components/Text';
export { default as TextInput } from './components/TextInput';
export { default as createCustomParser } from './createCustomParser';
export * from './extensions';
export { default as shouldForwardProp } from './shouldForwardProp';
export type { BaseStyledProps } from './styledFactory';
export type { SxProps } from './styledFactory';
export { default as styledFactory } from './styledFactory';
export * from './theme';
export { default as variantFactory } from './variantFactory';

/**
 * React Server Components errors on Namespaced components
 * so we re-export these without the namespace
 */

export const BoxInline = Box.inline;

export const BorderBoxInline = BorderBox.inline;

export const FlexBoxInline = FlexBox.inline;

export const H1 = Heading.h1;
export const H2 = Heading.h2;
export const H3 = Heading.h3;
export const H4 = Heading.h4;
export const H5 = Heading.h5;
export const H6 = Heading.h6;

export const BulletList = List.bulletList;
export const NumberList = List.numberList;
export const ListItem = List.listItem;

export const PositionAbsolute = Position.absolute;
// eslint-disable-next-line @typescript-eslint/no-deprecated
export const PositionFixed = Position.fixed;
export const PositionRelative = Position.relative;
export const PositionSticky = Position.sticky;

export const TextRoot = Text.root;
export const TextParagraph = Text.p;
export const TextInline = Text.inline;
export const TextSpan = Text.inline;
export const TextStrong = Text.strong;
export const TextEm = Text.em;
// eslint-disable-next-line @typescript-eslint/no-deprecated
export const TextSmall = Text.small;

export const TextInputArea = TextInput.area;
